/** Formatos do módulo Pedidos (pt-BR, como a planilha). */
import type { PedidoDetalhe, StatusPedido } from '@shared/types'
import type { PedidoInput } from '@shared/validation'

const NUM = new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
const MOEDA = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })
const MOEDA_CURTA = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', notation: 'compact', maximumFractionDigits: 1 })
const INT = new Intl.NumberFormat('pt-BR')

export const numero = (v: number | null | undefined) => (v === null || v === undefined ? '' : NUM.format(v))
export const moeda = (v: number | null | undefined) => (v === null || v === undefined ? '—' : MOEDA.format(v))
export const moedaCurta = (v: number) => MOEDA_CURTA.format(v)
export const inteiro = (v: number) => INT.format(v)
export const pct = (v: number | null | undefined) => (v === null || v === undefined ? '—' : `${NUM.format(v)}%`)

/** "24.000,50" | "24000.5" | "R$ 1.234" → número; vazio → null; inválido → NaN. */
export function lerNumeroBR(s: string): number | null {
  const t = s.replace(/R\$|\s/g, '').trim()
  if (!t) return null
  const normal = /,\d{1,2}$/.test(t) || /\.\d{3}(\.|,|$)/.test(t) ? t.replace(/\./g, '').replace(',', '.') : t.replace(',', '.')
  const n = Number(normal)
  return Number.isFinite(n) ? n : NaN
}

/** "2026-01-07" → "07.01.2026". */
export const dataBR = (iso: string | null | undefined) => (iso ? iso.split('-').reverse().join('.') : '—')

/** Detalhe → entrada do formulário, sem mudar nada (base para editar um campo só). */
export function paraEntrada(d: PedidoDetalhe): PedidoInput {
  return {
    ano: d.ano,
    stat: d.stat,
    cliente: d.cliente ?? '',
    pedido: d.pedido,
    orderWerc: d.orderWerc,
    proposta: d.proposta,
    dataEntrega: d.dataEntrega,
    entregou: d.entregou,
    transportadora: d.transportadora,
    valor: d.valor,
    aReceber: d.aReceber,
    nf: d.nf,
    prevPgmto: d.prevPgmto,
    ok: d.ok,
    itens: d.itensLista.map((i) => ({ quantidade: i.quantidade, produto: i.produto, complemento: i.complemento })),
    statusId: d.statusId,
  }
}

/**
 * Cores de EXIBIÇÃO dos 5 status (D1: amarelo, laranja claro, ciano, roxo, verde).
 * A cor da planilha (ped_status.cor_hex) fica guardada para a exportação; na tela
 * usamos tons que continuam distinguíveis também no tema escuro (o verde e o
 * pêssego da planilha são quase brancos e viravam cinza).
 */
const COR_EXIBICAO: Record<string, string> = {
  normal: '#F2D50F',
  preparacao: '#F59E4C',
  atencao: '#1FC8E3',
  entrega_futura: '#A855F7',
  finalizado: '#3DBE6A',
}

export const corDoStatus = (lista: StatusPedido[] | undefined, id: number | null) => {
  const s = lista?.find((x) => x.id === id)
  return s ? (COR_EXIBICAO[s.codigo] ?? s.corHex) : undefined
}
/** Valor do filtro para os pedidos SEM COR (status em aberto, classificar à mão). */
export const SEM_COR = 0

export const corExibicao = (s: StatusPedido) => COR_EXIBICAO[s.codigo] ?? s.corHex
